import { computed, inject, Injectable, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { Cart } from './models';
import { ApiService } from './api.service';

@Injectable({ providedIn: 'root' })
export class CartStore {
  private readonly api = inject(ApiService);
  readonly cart = signal<Cart | null>(null);
  readonly loading = signal(false);
  readonly error = signal('');
  readonly count = computed(() => this.cart()?.items.reduce((sum, item) => sum + item.quantity, 0) ?? 0);

  load() {
    this.loading.set(true);
    this.api.cart().pipe(finalize(() => this.loading.set(false))).subscribe({ next: response => this.accept(response.data), error: () => this.error.set('Cart could not be loaded. Please retry.') });
  }

  add(variantId: number, quantity = 1, onAdded?: () => void) {
    this.loading.set(true); this.error.set('');
    this.api.addToCart(variantId, quantity).pipe(finalize(() => this.loading.set(false))).subscribe({ next: response => { this.accept(response.data); onAdded?.(); }, error: error => this.error.set(error?.error?.message ?? 'This item could not be added.') });
  }

  update(itemId: number, quantity: number) {
    if (quantity < 1) return this.remove(itemId);
    this.api.updateCart(itemId, quantity).subscribe({ next: response => this.accept(response.data), error: error => this.error.set(error?.error?.message ?? 'Cart update failed.') });
  }

  remove(itemId: number) { this.api.removeCart(itemId).subscribe({ next: response => this.accept(response.data), error: () => this.error.set('Item could not be removed.') }); }

  accept(cart: Cart) { this.cart.set(cart); this.api.rememberCart(cart.cart_uuid); }
}
